'use client';

import React from 'react';
import Link from 'next/link';
import {
  CreditCard,
  Shield,
  Lock,
  Globe,
  Users,
  Building2,
  Zap,
  ArrowLeft,
} from 'lucide-react';

export default function DeepFintechCardsPage() {
  return (
    <main className="bg-[#f3eee8] text-[#3b2a22]">

      <style jsx global>{`
        body {
          background: #f3eee8;
        }

        .wrap {
          max-width: 1180px;
          margin: auto;
          padding: 120px 24px;
        }

        /* NAV */
        .nav {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          padding: 18px 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: rgba(243,238,232,0.85);
          backdrop-filter: blur(12px);
          border-bottom: 1px solid #e0d3c7;
          z-index: 50;
        }

        .nav a {
          font-size: 14px;
          font-weight: 500;
          color: #6b3f27;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        /* HERO */
        .hero {
          text-align: center;
          padding-top: 90px;
          margin-bottom: 80px;
        }

        .hero h1 {
          font-size: clamp(2.8rem, 5vw, 5rem);
          font-weight: 600;
          letter-spacing: -0.04em;
          line-height: 1.05;
        }

        .hero p {
          margin-top: 22px;
          max-width: 820px;
          margin-inline: auto;
          font-size: 18px;
          color: #75675e;
          line-height: 1.8;
        }

        /* CARD */
        .card-wrap {
          display: flex;
          justify-content: center;
          margin: 80px 0;
        }

        .card {
          width: 460px;
          height: 280px;
          border-radius: 26px;
          background: linear-gradient(135deg, #4a2d20, #6b3f27);
          color: white;
          padding: 22px;
          box-shadow: 0 90px 200px rgba(0,0,0,0.22);
        }

        /* SECTION */
        .section-title {
          font-size: 36px;
          font-weight: 600;
          margin-bottom: 14px;
        }

        .section-text {
          color: #75675e;
          font-size: 17px;
          line-height: 1.85;
          max-width: 900px;
          margin-bottom: 30px;
        }

        /* FEATURE BLOCK */
        .block {
          background: white;
          border: 1px solid #e0d3c7;
          border-radius: 18px;
          padding: 28px;
          margin-bottom: 20px;
        }

        .block h3 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .block p {
          font-size: 15px;
          line-height: 1.9;
          color: #75675e;
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 18px;
          margin-top: 30px;
        }

        /* CTA */
        .cta {
          text-align: center;
          margin-top: 110px;
        }

        .btn {
          background: #6b3f27;
          color: white;
          padding: 14px 24px;
          border-radius: 999px;
          display: inline-flex;
          gap: 10px;
          font-weight: 600;
        }

        .cards-section { position: relative; isolation: isolate; }
        .cards-section::before { content: ''; position: absolute; left: -180px; top: 80px; width: 420px; height: 420px; border-radius: 50%; background: radial-gradient(circle, rgba(107,63,39,0.08), transparent 68%); pointer-events: none; z-index: -1; }
        .cards-section-header { display: grid; grid-template-columns: minmax(180px, 0.75fr) minmax(0, 1.25fr); gap: 56px; align-items: end; margin-bottom: 42px; }
        .cards-section-kicker { display: flex; align-items: center; gap: 10px; margin-bottom: 20px; color: #6b3f27; font-size: 11px; font-weight: 700; letter-spacing: 0.16em; text-transform: uppercase; }
        .cards-section-kicker::before { content: ''; width: 28px; height: 1px; background: currentColor; }
        .cards-section-title { max-width: 480px; margin: 0; color: #3b2a22; font-size: clamp(2.3rem, 4vw, 4rem); font-weight: 600; letter-spacing: -0.055em; line-height: 0.98; text-wrap: balance; }
        .cards-section-intro { max-width: 620px; margin: 0 0 4px; color: #75675e; font-size: 17px; line-height: 1.8; text-wrap: pretty; }
        .spend-control-panel { position: relative; display: grid; grid-template-columns: minmax(180px, 0.7fr) minmax(0, 1.3fr); gap: 42px; overflow: hidden; padding: 34px; border-radius: 26px; background: #4a2d20; color: #f3eee8; box-shadow: 0 28px 70px rgba(74,45,32,0.16); }
        .spend-control-panel::before { content: ''; position: absolute; right: -90px; top: -120px; width: 360px; height: 360px; border: 1px solid rgba(234,216,200,0.15); border-radius: 50%; box-shadow: 0 0 0 34px rgba(234,216,200,0.04), 0 0 0 68px rgba(234,216,200,0.035); pointer-events: none; }
        .spend-control-label { position: relative; z-index: 1; align-self: start; color: #d5b28f; font-size: 12px; font-weight: 600; letter-spacing: 0.1em; line-height: 1.5; text-transform: uppercase; }
        .spend-control-label strong { display: block; margin-top: 18px; color: #f3eee8; font-size: clamp(2rem, 4vw, 3.5rem); font-weight: 500; letter-spacing: -0.06em; line-height: 0.95; text-transform: none; }
        .spend-control-list { position: relative; z-index: 1; display: grid; gap: 0; }
        .spend-control-row { display: grid; grid-template-columns: 42px minmax(0, 1fr); gap: 18px; padding: 18px 0; border-top: 1px solid rgba(242,231,220,0.18); }
        .spend-control-row:last-child { border-bottom: 1px solid rgba(242,231,220,0.18); }
        .spend-control-index, .compliance-card-number { color: #b58e70; font-size: 12px; font-variant-numeric: tabular-nums; letter-spacing: 0.08em; }
        .spend-control-row h3, .compliance-card h3, .subsidiary-impact h3 { margin: 0 0 8px; color: inherit; font-size: 19px; font-weight: 600; letter-spacing: -0.025em; }
        .spend-control-row p, .compliance-card p, .subsidiary-impact p { margin: 0; font-size: 15px; line-height: 1.75; }
        .spend-control-row p { color: #e1c9b2; }
        .compliance-layout { display: grid; grid-template-columns: minmax(180px, 0.65fr) minmax(0, 1.35fr); gap: 42px; align-items: stretch; padding: 28px; border: 1px solid #dfd0c2; border-radius: 26px; background: #f0e7dd; }
        .compliance-rail { display: flex; flex-direction: column; justify-content: space-between; min-height: 310px; padding: 10px 0 8px; }
        .compliance-rail-heading { max-width: 220px; margin: 0; color: #4a2d20; font-size: 22px; font-weight: 500; letter-spacing: -0.035em; line-height: 1.15; }
        .compliance-rail-status { display: flex; align-items: center; gap: 10px; color: #6b3f27; font-size: 11px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; }
        .compliance-rail-status::before { content: ''; width: 8px; height: 8px; border-radius: 50%; background: #6b3f27; box-shadow: 0 0 0 5px rgba(107,63,39,0.12); }
        .compliance-cards { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }
        .compliance-card { display: flex; flex-direction: column; min-height: 260px; padding: 24px; border: 1px solid rgba(107,63,39,0.16); border-radius: 18px; background: #fbf8f4; color: #4a2d20; transition: transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease; }
        .compliance-card:hover { border-color: rgba(107,63,39,0.34); box-shadow: 0 18px 38px rgba(74,45,32,0.1); transform: translateY(-3px); }
        .compliance-card-number { margin-bottom: auto; color: #9a6b4a; }
        .compliance-card p { color: #75675e; }
        .subsidiary-panel { position: relative; display: grid; grid-template-columns: minmax(0, 1.15fr) minmax(220px, 0.85fr); gap: 36px; overflow: hidden; padding: 32px; border-radius: 26px; background: #eee1d4; }
        .subsidiary-panel::after { content: ''; position: absolute; right: -120px; bottom: -150px; width: 390px; height: 390px; border: 1px solid rgba(107,63,39,0.16); border-radius: 50%; box-shadow: 0 0 0 42px rgba(107,63,39,0.05), 0 0 0 84px rgba(107,63,39,0.04); pointer-events: none; }
        .subsidiary-network { position: relative; min-height: 300px; border: 1px solid rgba(107,63,39,0.14); border-radius: 18px; background: linear-gradient(rgba(107,63,39,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(107,63,39,0.06) 1px, transparent 1px), rgba(251,248,244,0.56); background-size: 36px 36px; }
        .subsidiary-network::before, .subsidiary-network::after { content: ''; position: absolute; left: 22%; top: 50%; width: 58%; height: 1px; background: rgba(107,63,39,0.3); transform: rotate(-25deg); transform-origin: left center; }
        .subsidiary-network::after { transform: rotate(25deg); }
        .network-node { position: absolute; z-index: 1; display: grid; place-items: center; width: 64px; height: 64px; border: 1px solid rgba(107,63,39,0.3); border-radius: 50%; background: #fbf8f4; color: #6b3f27; font-size: 10px; font-weight: 700; letter-spacing: 0.07em; text-align: center; text-transform: uppercase; box-shadow: 0 8px 18px rgba(107,63,39,0.1); }
        .network-node::after { content: ''; position: absolute; width: 8px; height: 8px; border-radius: 50%; background: #6b3f27; box-shadow: 0 0 0 5px rgba(107,63,39,0.12); }
        .network-node.central { left: calc(50% - 32px); top: calc(50% - 32px); width: 76px; height: 76px; border-color: #6b3f27; background: #4a2d20; color: #f3eee8; }
        .network-node.central::after { display: none; }
        .network-node.north { left: 12%; top: 16%; }
        .network-node.east { right: 10%; top: 19%; }
        .network-node.south { right: 14%; bottom: 13%; }
        .subsidiary-impact { position: relative; z-index: 1; align-self: center; color: #4a2d20; }
        .subsidiary-impact-label { display: block; margin-bottom: 18px; color: #6b3f27; font-size: 11px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; }
        .subsidiary-impact p { color: #796c62; }
        @media (max-width: 760px) { .cards-section-header, .spend-control-panel, .compliance-layout, .subsidiary-panel { grid-template-columns: 1fr; } .cards-section-header { gap: 24px; margin-bottom: 28px; } .spend-control-panel, .subsidiary-panel { padding: 24px; } .compliance-layout { gap: 24px; padding: 20px; } .compliance-rail { min-height: auto; gap: 28px; } .compliance-cards { grid-template-columns: 1fr; } .compliance-card { min-height: 220px; } .subsidiary-network { min-height: 260px; } }
        @media (prefers-reduced-motion: reduce) { .compliance-card { transition: none; } }
      `}</style>

      {/* NAV */}
      <div className="nav">
        <Link href="/landing-page">
          <ArrowLeft size={16} />
          Back to OakPay Home
        </Link>

        <span style={{ fontSize: 13, color: '#75675e' }}>
          Corporate Cards Infrastructure
        </span>
      </div>

      <div className="wrap">

        {/* HERO */}
        <section className="hero">
          <h1>
            Corporate cards built for
            <span style={{ color: '#6b3f27', display: 'block' }}>
              financial control at enterprise scale
            </span>
          </h1>

          <p>
            OakPay corporate cards are not just payment tools — they are
            programmable financial instruments designed to enforce policy,
            manage risk, and give organizations real-time visibility into
            how money moves across teams, departments, and global operations.
          </p>
        </section>

        {/* CARD */}
        <div className="card-wrap">
          <div className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontSize: 12, opacity: 0.8 }}>Virtual Card</span>
              <CreditCard size={18} />
            </div>

            <div style={{ marginTop: 75, letterSpacing: 2 }}>
              •••• 4829
            </div>

            <div style={{ marginTop: 10, fontSize: 18, fontWeight: 600 }}>
              OakPay Business
            </div>

            <div style={{ marginTop: 40, fontSize: 12, opacity: 0.75 }}>
              Policy Engine • Controls • Real-time enforcement
            </div>
          </div>
        </div>

        {/* SPEND CONTROLS */}
        <section className="cards-section" aria-labelledby="spend-controls-title">
          <div className="cards-section-header">
            <div>
              <div className="cards-section-kicker">01 / Policy engine</div>
              <h2 id="spend-controls-title" className="cards-section-title">Spend Controls</h2>
            </div>
            <p className="cards-section-intro">
              Spend controls define the financial boundaries of your organization.
              Instead of reacting to expenses after they occur, OakPay enforces
              rules before transactions are approved. This includes limits by
              employee, department, vendor category, and transaction type.
              The goal is not restriction — but predictable financial governance.
            </p>
          </div>
          <div className="spend-control-panel">
            <div className="spend-control-label">
              Governance before reconciliation
              <strong>Rules that hold<br />at the point of spend.</strong>
            </div>
            <div className="spend-control-list">
              <article className="spend-control-row"><span className="spend-control-index">01</span><div><h3>Why it matters</h3><p>Without structured spend controls, organizations lose visibility and accumulate uncontrolled financial leakage. Enterprises require predictability — especially when scaling across teams and regions. Spend controls ensure every transaction aligns with company policy before money is spent, not after reconciliation.</p></div></article>
              <article className="spend-control-row"><span className="spend-control-index">02</span><div><h3>How it works</h3><p>Each card is bound to a programmable policy engine. When a transaction is initiated, it is evaluated against predefined rules such as budget caps, merchant restrictions, and approval flows. If it violates any condition, the transaction is automatically blocked or routed for approval.</p></div></article>
              <article className="spend-control-row"><span className="spend-control-index">03</span><div><h3>Enterprise implications</h3><p>At scale, spend controls reduce financial risk exposure, eliminate manual auditing bottlenecks, and allow finance teams to operate proactively instead of reactively. This creates a controlled financial environment across global operations.</p></div></article>
            </div>
          </div>
        </section>

        {/* COMPLIANCE AUTOMATION */}
        <section className="cards-section" aria-labelledby="compliance-automation-title" style={{ marginTop: 120 }}>
          <div className="cards-section-header">
            <div>
              <div className="cards-section-kicker">02 / Continuous assurance</div>
              <h2 id="compliance-automation-title" className="cards-section-title">Compliance Automation</h2>
            </div>
            <p className="cards-section-intro">
              Compliance automation ensures that every financial action is
              aligned with internal policies and external regulatory frameworks.
              Instead of relying on manual audits, OakPay continuously evaluates
              transactions against compliance rules in real time.
            </p>
          </div>
          <div className="compliance-layout">
            <div className="compliance-rail"><p className="compliance-rail-heading">Every transaction leaves a clear, reviewable trail.</p><div className="compliance-rail-status">Rules active in real time</div></div>
            <div className="compliance-cards">
              <article className="compliance-card"><span className="compliance-card-number">01 / Risk posture</span><div><h3>Why it matters</h3><p>Enterprises operate under strict regulatory environments. Manual compliance processes are slow, error-prone, and expensive. Automation reduces operational overhead and improves financial accuracy at scale.</p></div></article>
              <article className="compliance-card"><span className="compliance-card-number">02 / Rule evaluation</span><div><h3>How it works</h3><p>Every transaction is tagged, categorized, and validated through automated rule sets. These rules are continuously updated based on internal policies, audit requirements, and financial governance frameworks.</p></div></article>
            </div>
          </div>
        </section>

        {/* GLOBAL MANAGEMENT */}
        <section className="cards-section" aria-labelledby="global-management-title" style={{ marginTop: 120 }}>
          <div className="cards-section-header">
            <div>
              <div className="cards-section-kicker">03 / Distributed control</div>
              <h2 id="global-management-title" className="cards-section-title">Global Subsidiary Management</h2>
            </div>
            <p className="cards-section-intro">
              Organizations operating across multiple regions require financial
              separation between subsidiaries while maintaining centralized control.
              OakPay enables distributed financial operations under a unified
              system architecture.
            </p>
          </div>
          <div className="subsidiary-panel">
            <div className="subsidiary-network" aria-hidden="true"><div className="network-node north">EMEA</div><div className="network-node east">APAC</div><div className="network-node south">AMER</div><div className="network-node central">OakPay<br />control</div></div>
            <article className="subsidiary-impact"><span className="subsidiary-impact-label">Enterprise impact</span><h3>Local autonomy, held to one operating standard.</h3><p>This structure allows multinational companies to maintain local financial autonomy while preserving global oversight, reporting consistency, and consolidated financial intelligence across all subsidiaries.</p></article>
          </div>
        </section>
{/* FINAL CTA SECTION */}

<section
  style={{
    marginTop: '180px',
    paddingBottom: '120px',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
  }}
>

  {/* TEXT CONTENT */}

  <div
    style={{
      position: 'relative',
      zIndex: 5,
      maxWidth: '760px',
      margin: '0 auto',
    }}
  >

    <h2
      style={{
        fontSize: 'clamp(3rem, 5vw, 5.5rem)',
        lineHeight: 1,
        letterSpacing: '-0.06em',
        fontWeight: 600,
        color: '#3b2a22',
        marginBottom: '22px',
      }}
    >
      See what OakPay can do for you.
    </h2>

    <p
      style={{
        fontSize: '18px',
        lineHeight: 1.7,
        color: '#75675e',
        maxWidth: '620px',
        margin: '0 auto',
      }}
    >
      Get the spending power you want and the controls you need today.
    </p>

    {/* CTA BUTTON */}

    <div
      style={{
        marginTop: '34px',
      }}
    >

      <Link
        href="/welcome"
        style={{
          height: '56px',
          padding: '0 26px',
          borderRadius: '999px',
          background: '#6b3f27',
          color: 'white',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 600,
          fontSize: '15px',
          textDecoration: 'none',
          boxShadow: '0 18px 40px rgba(107,63,39,0.18)',
          transition: 'all 0.25s ease',
        }}
      >
        Get started
      </Link>

    </div>

  </div>

  {/* CARD AREA */}

  <div
    style={{
      position: 'relative',
      marginTop: '120px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      perspective: '1800px',
    }}
  >

    {/* RADIAL GLOW */}

    <div
      style={{
        position: 'absolute',
        width: '700px',
        height: '700px',
        borderRadius: '999px',
        background:
          'radial-gradient(circle, rgba(107,63,39,0.18) 0%, rgba(107,63,39,0.08) 35%, transparent 70%)',
        filter: 'blur(40px)',
        zIndex: 1,
      }}
    />

    {/* SHADOW */}

    <div
      style={{
        position: 'absolute',
        width: '460px',
        height: '120px',
        background: 'rgba(0,0,0,0.18)',
        filter: 'blur(55px)',
        borderRadius: '999px',
        transform: 'translateY(180px)',
        zIndex: 1,
      }}
    />

    {/* FLOATING CARD */}

   <img
  src="/oakpay-card.png"
  alt="OakPay Card"
  style={{
    width: 'min(1040px, 98vw)',
    maxWidth: '1040px',
    position: 'relative',
    zIndex: 5,

    transform: `
      rotateX(18deg)
      rotateY(-18deg)
      rotateZ(6deg)
      translateY(0px)
    `,

    transformStyle: 'preserve-3d',

    filter:
      'drop-shadow(0 70px 120px rgba(0,0,0,0.28))',

    transition: 'transform 0.6s cubic-bezier(0.22,1,0.36,1)',
  }}
/>

  </div>

</section>
        {/* CTA */}
        <div className="cta">
          <Link href="/welcome" className="btn">
            
          </Link>
        </div>

      </div>
    </main>
  );
  
}
